export enum OrdersTab {
  ACTIVE = 'active',
  HISTORY = 'history',
}
